<template>
  <div class="delivery-info">
    <div class="iw-item-name delivery-info__title">{{ activeVendor?.name }}</div>
    <div class="iw-body-text-small">
      <span>{{ layout.levelLabel }}: {{ selectedLevel.name }}</span>
      <span>{{ layout.sectionLabel }}: {{ selectedSection.name }}</span>
      <span>{{ layout.rowLabel }}: {{ selectedRow.name }}</span>
      <span>{{ layout.seatLabel }}: {{ selectedSeat.name }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DeliveryInfo",
  computed: {
    ...mapGetters({
      selectedLevel: "delivery/getSelectedLevel",
      selectedSection: "delivery/getSelectedSection",
      selectedRow: "delivery/getSelectedRow",
      selectedSeat: "delivery/getSelectedSeat",
      activeVendor: "vendor/getActiveVendor",
      layout: "venueSettings/getLayout"
    })
  }
};
</script>

<style scoped lang="scss">
.delivery-info {
  &__title {
    margin-bottom: 7px;
  }
  span {
    margin-right: 12px;
  }
}
</style>
